import { render } from "./ShowScore.vue?vue&type=template&id=697eaf09"
import script from "./ShowScore.vue?vue&type=script&lang=ts"
export * from "./ShowScore.vue?vue&type=script&lang=ts"
script.render = render

export default script